import React, { useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { Container, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../../style/Blog.css';

const Login = () => {
  const { loginUser } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    await loginUser(email, password);
  };

  return (
    <Container className="mt-5 d-flex justify-content-center">
      <div className="retro-window" style={{ width: '100%', maxWidth: '400px' }}>
      <div className="window-dots mb-3">
  <span className="dot red" />
  <span className="dot yellow" />
  <span className="dot green" />
</div>
<h2 className="text-center mb-4">Login</h2>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
              size="sm"
            />
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
              size="sm"
            />
          </Form.Group>
          <button
            type="submit"
            disabled={!email || !password}
            className="retro-button w-100 small-btn"
          >
            Login
          </button>
        </Form>
        <p className="mt-3 text-center fs-6">
          Don't have an account?{' '}
          <Link to="/register" className="link-danger">Register</Link>
        </p>
      </div>
    </Container>
  );
};

export default Login;
